import { ChangeEventHandler, RefObject } from 'react'
import * as S from './ButtonFileSelect.styles'
import theme from 'src/styles/theme'
import { SxProps, Theme } from '@mui/material'

interface ButtonFileSelectProps {
  id: string;
  name: string;
  title: string;
  accept?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  ref?: ((instance: HTMLInputElement) => void) | RefObject<HTMLInputElement>;
  testId?: string;
  bgColor?: keyof typeof theme.colors;
  hoverColor?: keyof typeof theme.colors;
  letterColor?: keyof typeof theme.colors;
  disabled?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

const ButtonFileSelect = ({
  id,
  name,
  title,
  accept,
  onChange,
  ref,
  testId,
  bgColor,
  hoverColor,
  letterColor,
  disabled = false,
  fullWidth = false,
  sx,
}: ButtonFileSelectProps) => {
  const handleClick = (event: any) => {
    event.target.value = ''
  }

  return (
    <S.Button
      sx={sx}
      data-testid={testId}
      $bgColor={disabled ? theme.colors.disabled : bgColor && theme.colors[bgColor]}
      $hoverColor={hoverColor && theme.colors[hoverColor]}
      $letterColor={letterColor && theme.colors[letterColor]}
      variant='contained'
      component='label'
      fullWidth={fullWidth}
    >
      {title}
      <S.Input
        type='file'
        id={id}
        name={name}
        accept={accept}
        onClick={handleClick}
        onChange={onChange}
        ref={ref}
        hidden
      />
    </S.Button>
  )
}

export { ButtonFileSelect }
